import * as React from 'react';
import styled from 'styled-components';

import { FlyoutTileItem, getFilenameAndExtension } from '@packages/common';
import { media, themeGet } from '@packages/ui';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

const ASSETS_URL = getPublicRuntimeConfig('ASSETS_URL');

const FLYOUT_TEASER_HEIGHTS = {
  normal: '136px',
  xxl: '107px',
  xl: '80px',
};

export const ImageContainer = styled.div`
  background-color: ${themeGet.colors('white')};
  background-size: 70% 96%;
  background-position: center top;
  background-repeat: no-repeat;
  min-height: ${FLYOUT_TEASER_HEIGHTS.normal};

  ${media.to.xxl`
    min-height: ${FLYOUT_TEASER_HEIGHTS.xxl};
  `};

  ${media.to.xl`
    min-height: ${FLYOUT_TEASER_HEIGHTS.xl};
  `};
`;

export const ImgStyled = styled.img`
  width: 70%;
  margin-left: auto;
  margin-right: auto;
  height: auto;
  background-color: ${themeGet.colors('swirl')};
`;

interface FlyoutTileImageProps {
  flyoutTile: FlyoutTileItem;
}

export const FlyoutTileImage: React.FC<FlyoutTileImageProps> = ({ flyoutTile }) => {
  const imgSize = '189x126';
  const [imgFilename, imgFileExtension] = getFilenameAndExtension(flyoutTile.src || '');
  const src = `${ASSETS_URL}/flyout/${imgFilename}-${imgSize}.${imgFileExtension}?quality=85`;
  return (
    <ImageContainer>
      <ImgStyled src={src} srcSet={`${src} 189w`} />
    </ImageContainer>
  );
};
